import { FC } from 'react';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { AlertListTableItem, CompAlertStatus } from '@/api';

import styles from './TableActions.module.sass';

interface TableActionsProps {
  record: AlertListTableItem;
  onStatusChange: (id: string, status: CompAlertStatus) => void;
}

const TableActions: FC<TableActionsProps> = ({ record, onStatusChange }) => {
  const onItemConfirm = () => onStatusChange(record.id, 'confirmed');
  const onItemReject = () => onStatusChange(record.id, 'rejected');

  if (record.state !== 'new') {
    return null;
  }

  return (
    <div className={styles.actions}>
      <button
        type="button"
        className={`${styles.btn} ${styles.btn_confirm}`}
        onClick={onItemConfirm}
      >
        <CheckOutlined />
      </button>
      <button
        type="button"
        className={`${styles.btn} ${styles.btn_reject}`}
        onClick={onItemReject}
      >
        <CloseOutlined />
      </button>
    </div>
  );
};

export default TableActions;
